import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { defineCustomElements } from "@ionic/pwa-elements/loader";

import {
  register as registerSwiperElement,
  register as registerSwiperElements,
} from "swiper/element/bundle";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

registerSwiperElements();

defineCustomElements(window);
if (environment.production) {
  enableProdMode();
  const noop = () => undefined;
  console.log = noop;
  console.debug = noop;
}

registerSwiperElement();
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
